<header class="pc-header">
  <div class="header-wrapper">
    <div class="pc-mob-drp">
      <app-nav-left [navCollapsed]="navCollapsed" (NavCollapse)="navCollapse()" (NavCollapsedMob)="navCollapseMob()" (RoleSelectorToggle)="onRoleSelectorToggle()"></app-nav-left>
    </div>
    <div>
      <app-nav-right (settingsSidebarToggle)="onSettingsSidebarToggle()" />
    </div>
  </div>
</header>
